// Step 1: Add 'active' to .dropdown-submenu if it contains .menu-item.actives
document.querySelectorAll('.dropdown-submenu').forEach(submenu => {
  if (submenu.querySelector('.menu-list .menu-item.actives')) {
    submenu.classList.add('active');
  }
});

// Step 2: Add 'no-padding' to .header-nav if it contains any .dropdown-submenu.active
document.querySelectorAll('.header-wrapper .header-nav').forEach(nav => {
  if (nav.querySelector('.dropdown-submenu.active')) {
    nav.classList.add('no-padding');
  }
});


document.addEventListener('DOMContentLoaded', function () {
    var commentText = document.getElementById('comment_text');
    var commentHidden = document.getElementById('comment_checkout');

    if (commentText && commentHidden) {
      // jab bhi user type kare
      commentText.addEventListener('input', function () {
        commentHidden.value = this.value;
      });
    }
  });